// This icon file is generated automatically.
var PZoomInOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M8.95 5.92H7.11v-2.1a.13.13 0 00-.13-.12h-.93a.13.13 0 00-.13.13v2.1H4.08a.13.13 0 00-.13.12v.93c0 .07.06.13.13.13h1.84v2.1c0 .06.06.12.13.12h.93c.07 0 .13-.06.13-.13V7.1h1.84c.07 0 .13-.05.13-.12v-.93a.13.13 0 00-.13-.13zm4.44 6.63l-2.28-2.28a5.93 5.93 0 10-.84.84l2.28 2.28c.05.04.13.04.17 0l.67-.67c.04-.04.04-.12 0-.17zM9.87 9.87a4.75 4.75 0 11-6.71-6.72 4.75 4.75 0 016.71 6.72z", "fill-rule": "nonzero" } }] }, "name": "p-zoom-in", "theme": "outlined" };
export default PZoomInOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PZoomInOutlined.js
// module id = 3747
// module chunks = 0